export function quizCreateError(response) {
  if (response.status === 429) {
    const parsedRetryAfter = Number(response.headers.get("Retry-After"));
    const retryAfter = Number.isFinite(parsedRetryAfter) && parsedRetryAfter > 0
      ? Math.ceil(parsedRetryAfter)
      : 60;
    return new Error(
      `Uruchomiono zbyt wiele nowych testów. Spróbuj ponownie za ${retryAfter} s.`,
    );
  }

  if (response.status === 503) {
    return new Error(
      "Tworzenie testu jest chwilowo niedostępne. Spróbuj ponownie za moment.",
    );
  }

  return null;
}
